import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'spw-footer-content',
  styleUrl: 'spw-footer-content.scss',
  shadow: true,
})
export class SpwFooterContent {
  render() {
    return (
      <Host>
        <div class="spw-footer-content">
          <div class="spw-footer-content__container spw-ds-container spw-tw-px-4 spw-tw-mx-auto">
            <slot></slot>
          </div>
        </div>
      </Host>
    );
  }
}
